import {Component, OnInit} from '@angular/core';
import {faCheckCircle} from '@fortawesome/free-regular-svg-icons';

@Component({
    selector: 'app-payment-success',
    templateUrl: './payment-success.component.html',
    styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {
    faCheckCircle = faCheckCircle;
    linkTo: string;

    constructor() {
        if (sessionStorage.getItem('cod_contract')) {
            this.linkTo = `/contratos/${sessionStorage.getItem('cod_contract')}`;
        } else {
            this.linkTo = '/contratos';
        }
    }

    ngOnInit(): void {

    }

}
